export const PT_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST—PHYSICAL THERAPIST",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Knowledge of Assessment Process:",
                items: [
                    "a. Health history and physical exam",
                    "b. Development of Problem List",
                    "c. Development and revision of care plan",
                    "d. Assesses response to treatment",
                    "e. Establishes and revises goals",
                    "f. DC planning",
                    "g. Conducts complete initial valuation",
                    "h. Other"
                ]
            },
            {
                category: "2. Documentation Skills: (accurate, legible, timely, and complete)",
                items: [
                    "a. 485, 486, 487",
                    "b. Progress notes, flow charts",
                    "c. Summary report",
                    "d. Incident/Variance reporting",
                    "e. Other"
                ]
            },
            {
                category: "3. Adheres to POC",
                items: [
                    "a. Reviews POC prior to care",
                    "b. Performs services as ordered",
                    "c. Documents according to POC",
                    "d. Communicates/coordinates if appropriate",
                    "e. Other"
                ]
            }
        ]
    },

    // Page 2: Administrative Continued
    {
        id: 2,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate: (continued)",
        competencies: [
            {
                category: "4. Knowledge of Medicare/State Guidelines:",
                items: [
                    "a. Criteria for participation",
                    "b. Skilled reimbursable visit",
                    "c. Skilled reimbursable visit",
                    "d. Other"
                ]
            },
            {
                category: "5. Reports and documents key information to Physician, DC Planner, Clinician, Pharmacist, Supervisor"
            },
            {
                category: "6. Participates as team member"
            },
            {
                category: "7. Submits written summary reports as indicated"
            },
            {
                category: "8. Attends/participates in case conference as required"
            },
            {
                category: "9. Supervision of Ancillary Personnel:",
                items: [
                    "a. PTA (Physical Therapist Assistant)",
                    "b. HHA (Home Health Aide)"
                ]
            },
            {
                category: "10. Supply/HME requisition and management"
            },
            {
                category: "11. Infection Control Practices:",
                items: [
                    "a. Hand washing",
                    "b. Personal protective equipment",
                    "c. Exposure control plan",
                    "d. Equipment care, as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "12. Patient home safety"
            },
            {
                category: "13. Other"
            }
        ]
    },

    // Page 3: Patient Education & Clinical Skills
    {
        id: 3,
        type: 'section',
        title: "B. Patient Education & Clinical Skills:",
        competencies: [
            {
                category: "B. Patient Education:",
                items: [
                    "1. Determines learning needs",
                    "2. Sets objectives",
                    "3. Develops/implement teaching plan",
                    "4. Evaluates effectiveness of teaching",
                    "5. Revises teaching plan",
                    "6. Documents patient response",
                    "7. Other"
                ]
            },
            {
                category: "C. Clinical Skills—General:",
                items: [
                    "1. Vital Signs/I&O (Intake and Output)",
                    "2. Other"
                ]
            }
        ]
    },

    // Page 4: Assessment and Evaluation
    {
        id: 4,
        type: 'section',
        title: "D. Assessment and Evaluation:",
        competencies: [
            {
                category: "D. Assessment and Evaluation:",
                items: [
                    "1. Cognition/communication",
                    "2. Musculoskeletal-Skeletal (ROM, posture, deformity)",
                    "3. Pain (location, intensity, relief)",
                    "4. Neuro-Muscular Function (motor control, strength, coordination, tone, reflexes)",
                    "5. Sensation",
                    "6. Endurance",
                    {
                        text: "7. Functional Findings:",
                        subItems: [
                            "a. Bed mobility",
                            "b. Gait",
                            "c. Transfers",
                            "d. Equipment management"
                        ]
                    },
                    "8. Environmental eval/architectural barriers",
                    "9. Other tests or measurements"
                ]
            }
        ]
    },

    // Page 5: Skilled Treatments/Interventions
    {
        id: 5,
        type: 'section',
        title: "E. Skilled Treatments/Interventions:",
        competencies: [
            {
                category: "E. Skilled Treatments/Interventions:",
                items: [
                    {
                        text: "1. Perform therapeutic exercises:",
                        subItems: [
                            "a. Active",
                            "b. Passive",
                            "c. Strengthening and endurance"
                        ]
                    },
                    "2. Transfer Activities",
                    {
                        text: "3. Mobilization:",
                        subItems: [
                            "a. Bed mobility",
                            "b. Gait training",
                            "c. Other"
                        ]
                    },
                    {
                        text: "4. Use of Physical agents:",
                        subItems: [
                            "a. Ultrasound",
                            "b. Hot/cold packs",
                            "c. TENS/FES",
                            "d. Massage",
                            "e. Other"
                        ]
                    },
                    {
                        text: "5. Prosthetic Training:",
                        subItems: [
                            "a. Care of prosthesis",
                            "b. Stump conditioning",
                            "c. Other"
                        ]
                    },
                    {
                        text: "6. Assistive Devices:",
                        subItems: [
                            "a. Fit/adjustment",
                            "b. Gait training",
                            "c. Safety",
                            "d. Other"
                        ]
                    },
                    "7. Fabricates orthotic device, instructs in use",
                    "8. Management and evaluation of the patients care plan",
                    "9. Other"
                ]
            }
        ]
    },

    // Page 6: Comments & Signatures
    {
        id: 6,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Clinician Signature", name: "clinicianSignature" },
            { label: "Date", name: "clinicianDate", inputType: "date" },
            { label: "Evaluator Signature", name: "evaluatorSignature" },
            { label: "Date", name: "evaluatorDate", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 7,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const PT_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Physical Therapist",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The physical therapist contracted or employed through the Organization is responsible for providing physical therapy services and for adherence to all conditions outlined in the Personnel Services Agreement."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            {
                main: "Provides physical therapy services to patients according to a written physician's plan of care. This may include, but will not be limited to:",
                subItems: [
                    "Assessing and evaluating therapeutic/rehabilitative/functional status, and participation in the development of the total plan of care. Evaluates home environment.",
                    "Assesses for muscle strength, mobility, gait, ROM—potential for rehab.",
                    "Directing physical therapy treatment.",
                    "Instructing patients and families/caregivers in the use and care of therapeutic appliances.",
                    "Determining priority needs for physical therapy",
                    "Reporting to physician patient's reaction to treatment or changes in condition."
                ]
            },
            "Initiates physical therapy program and instructs other personnel and/or family/caregiver members in certain phases of physical therapy with which they may work with a patient, as well as instructing them as to the goals of the physical therapy program for the patient by participating in case conferences.",
            "May train patient in the use of prosthetic device.",
            "Identifies patient and family/caregiver needs for other home health services and refers as necessary.",
            "Prepares and submits clinical and progress summaries based on the attainment of goals.",
            "Participates in discharge planning for patient.",
            "Prepares and submits a clinical progress summary based on the attainment of goals as directed by Organization policy.",
            "Provides physical therapy consultation to home families/caregivers when indicated.",
            "Provides inservice education programs for nursing organization personnel as needed.",
            "Participates in peer consultation process.",
            "Supervises Physical Therapy Assistants according to organization policy and state regulations.",
            "When therapy is the only skilled service, instructs, supervises and evaluates home health aide care every two (2) weeks."
        ],
        generalStatement: "The above statements are intended to be a representative summary of the major duties and responsibilities performed by incumbents of this job. The incumbents may be requested to perform job related tasks other than those stated in this description."
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Possesses a degree from a baccalaureate or masters program in physical therapy approved by an accredited organization.",
            "Licensed to practice as physical therapist within the State, if applicable.",
            "Two years of appropriate experience as a physical therapist. Community/home health experience is preferred.",
            "Demonstrates good verbal and written communication and organization skills.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
